<script setup lang="ts">
// ================================
// Emits
// ================================
const emits = defineEmits<{
  (e: 'sendMessage', message: string): void;
}>();

// ================================
// Data
// ================================
const message = ref('');

// ================================
// Methods
// ================================
const sendMessage = () => {
  emits('sendMessage', message.value);
  message.value = '';
};
</script>
<template>
  <div class="flex flex-col items-center justify-center w-full pb-8">
    <div class="w-full max-w-[640px] rounded-lg bg-white border border-gray-200 shadow-sm">
      <u-textarea
        v-model="message"
        class="w-full border-none"
        autoresize
        :placeholder="$t('assistant.type_your_message')"
        :ui="{
          base: 'border-none ring-0 focus-visible:ring-0 focus-visible:ring-offset-0 p-4',
        }"
        @keydown.enter.prevent="sendMessage"
      />
      <div class="flex items-center justify-between p-2">
        <div></div>
        <u-button variant="solid" size="sm" icon="lucide-arrow-up" @click="sendMessage" />
      </div>
    </div>
  </div>
</template>
